import { createFileRoute, redirect } from '@tanstack/react-router'
import Login from '@pages/Login'
import client from '@lib/api/client'
import { getUserProfile, setUserProfile } from '@lib/auth/profileStorage'
import { ROLE_NAMES, ROUTES } from '@features/Login/constants'
import type { GetProfileQueryResponse } from '@/sdk-client/gen/models/usersModels/GetProfile'

const getRedirectRouteByRole = async () => {
  const cachedRole = getUserProfile()?.roles?.[0]?.name

  if (cachedRole === ROLE_NAMES.ADMINISTRATOR) {
    return ROUTES.USER_MANAGEMENT
  }

  if (cachedRole) {
    return ROUTES.APPROVALS
  }

  try {
    const { data: profileResponse } = await client<GetProfileQueryResponse>({
      method: 'get',
      url: '/api/Users/profile'
    })
    const profile = profileResponse?.result
    const fetchedRole = profile?.roles?.[0]?.name

    if (profile) {
      setUserProfile(profile)
    }

    if (fetchedRole === ROLE_NAMES.ADMINISTRATOR) {
      return ROUTES.USER_MANAGEMENT
    }
  } catch {
    return ROUTES.APPROVALS
  }

  return ROUTES.APPROVALS
}

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const isLoggedIn = await context.auth.strategy?.isLoggedIn()

    if (isLoggedIn) {
      const redirectRoute = await getRedirectRouteByRole()
      throw redirect({ to: redirectRoute })
    }
  },
  component: () => <Login />
})
